export class ProficiencyLevel {
    id: string;
    name: string;
    description: string;
}